import { Star } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { mockData } from "../mock";

export const Testimonials = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-blue-50 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Depoimentos de Clientes
          </h1>
          <p className="text-xl text-gray-600">
            Veja o que nossos clientes dizem sobre nossos serviços e a
            qualidade do nosso trabalho
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mockData.testimonials.map((testimonial) => (
              <Card
                key={testimonial.id}
                className="hover:shadow-xl transition-shadow"
              >
                <CardContent className="p-8">
                  <div className="flex items-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        size={20}
                        className="fill-yellow-400 text-yellow-400"
                      />
                    ))}
                  </div>
                  
                  <p className="text-gray-600 mb-6 text-lg italic leading-relaxed">
                    "{testimonial.content}"
                  </p>
                  
                  <div className="flex items-center pt-4 border-t">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-14 h-14 rounded-full mr-4 object-cover"
                    />
                    <div>
                      <p className="font-semibold text-gray-900 text-lg">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-gray-500">{testimonial.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Números Que Comprovam Nossa Qualidade
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-white rounded-lg shadow-md">
              <div className="text-5xl font-bold text-blue-600 mb-2">98%</div>
              <p className="text-lg text-gray-600">Taxa de Satisfação</p>
            </div>
            <div className="text-center p-8 bg-white rounded-lg shadow-md">
              <div className="text-5xl font-bold text-blue-600 mb-2">500+</div>
              <p className="text-lg text-gray-600">Projetos Concluídos</p>
            </div>
            <div className="text-center p-8 bg-white rounded-lg shadow-md">
              <div className="text-5xl font-bold text-blue-600 mb-2">4.9</div>
              <p className="text-lg text-gray-600">Avaliação Média</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Faça Parte dos Nossos Clientes Satisfeitos
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Entre em contato e descubra como podemos transformar seu ambiente
          </p>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
